export { getUAResult } from './uaParser';
